


import axios from 'axios';
// Create the axios instance with baseURL
const authAxios = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT
  // baseURL: process.env.REACT_APP_API_ENDPOINT_PROD
});
// Request interceptor to add the auth_token dynamically from localStorage
authAxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    // If a token exists, attach it to the Authorization header
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    
    return config;
  },
  
  (error) => {
    let {
        response: {
          data: { status,message },
        },
      } = error;

   
    if(message == "jwt malformed"){
        window.location.href="/login"
    }
    // Handle the error
    return Promise.reject(error);
  }
);
export default authAxios;